import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-wrapper" }
const _hoisted_2 = { class: "text px-3 is-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.fromItem) + " - " + _toDisplayString(_ctx.toItem) + " of " + _toDisplayString(_ctx.totalAmount), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["arrow material-icons is-clickable", { 'disabled': _ctx.currentPage === 1 }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
    }, " chevron_left ", 2),
    _createElementVNode("span", {
      class: _normalizeClass(["arrow material-icons is-clickable", { 'disabled': _ctx.currentPage === _ctx.totalPages }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
    }, " chevron_right ", 2)
  ]))
}